import { useNavigate } from 'react-router';
import browserHistory from '~/history';
import { Colors } from '~/themes/colors';
import { Row } from '../Row';
import { Text } from '../Text';
import { IBackWhiteButtonProps } from './Types';
import { Icon } from '../Icon';

export const BackWhiteButton = ({
  whiteArrow,
  containerStyle = {},
  backRoute,
}: IBackWhiteButtonProps) => {
  const navigate = useNavigate();

  return (
    <Row
      alignItems="center"
      cursor="pointer"
      justifyContent="center"
      marginLeft={10}
      style={containerStyle}
      width="100%"
      onClick={() => (backRoute ? browserHistory.push(backRoute) : navigate(-1))}
    >
      <Icon name="arrow-left" color={whiteArrow ? Colors.white : Colors.secondary_500} size={20} />
      <Text bold color={Colors.white} fontSize={22} textAlign="left" width="100%" cursor="pointer">
        Back
      </Text>
    </Row>
  );
};
